import React, { useEffect } from 'react';
import classnames from 'classnames';
import FacebookPageConnector from '../../../dashboard/pages/SignupOnboarding/pages/1-ConnectPages/FacebookPageConnector/FacebookPageConnector';
import Button from '../../buttons/DeprecatedButton/DeprecatedButton';
import { StoreState } from '@mm/state/store-interfaces';
import {
  selectActiveCompanyId,
  selectCompanies,
} from '@mm/state/selectors/viewSelectors';
import { unconnectedPagesSelector } from '@mm/state/modules/modalsState/selectors';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import connectedPageCRUDActions from '@mm/state/actions/ConnectedPageCRUDActions';
import ConnectedPageModel from '@mm/state/model/ConnectedPageModel';
import ChatbotModel from '@mm/state/model/ChatbotModel';

type OuterProps = {
  afterPageConnect: (response: {
    facebookPage: ConnectedPageModel;
    bot: ChatbotModel;
  }) => any;
  className?: string;
};

type InnerProps = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

type Props = OuterProps & InnerProps;

const NoPages = () => (
  <div className="connect-pages__create-pages">
    <span>{"Looks like you don't have any Facebook pages."}</span>

    <a
      href="https://www.facebook.com/pages/create/"
      target="_blank"
      rel="noopener noreferrer"
    >
      <Button className="connect-pages__create-button">
        Create Facebook Page
      </Button>
    </a>
  </div>
);

const ConnectPagesArea = (props: Props) => {
  const {
    unconnectedPages,
    fetchMorePages,
    nextAvailablePages,
    afterPageConnect,
    getConnectedPages,
    className,
  } = props;

  useEffect(() => {
    getConnectedPages();
  }, []);

  const onListScroll = (e: React.SyntheticEvent<HTMLDivElement>) => {
    if (e.currentTarget) {
      const reachedEnd =
        e.currentTarget.offsetHeight + e.currentTarget.scrollTop >=
        e.currentTarget.scrollHeight;

      if (reachedEnd && nextAvailablePages) {
        fetchMorePages('', nextAvailablePages);
      }
    }
  };

  const classList = classnames('connect-pages-area', className);

  return (
    <div className={classList} onScroll={onListScroll}>
      {unconnectedPages.map(unconnectedPage => (
        <FacebookPageConnector
          key={unconnectedPage.remoteId}
          onboarding={false}
          pageInfo={unconnectedPage}
          afterPageConnect={afterPageConnect}
        />
      ))}

      {!unconnectedPages.length && <NoPages />}
    </div>
  );
};

const mapStateToProps = (state: StoreState) => ({
  companies: selectCompanies(state),
  companyId: selectActiveCompanyId(state),
  chatbots: state.chatbot.entities,
  connectedPages: state.connectedPage.entities,
  nextAvailablePages: state.connectedPage.availablePages.next,
  unconnectedPages: unconnectedPagesSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch<StoreState>) => ({
  getConnectedPages: () => dispatch(connectedPageCRUDActions.retrieveAll()),
  fetchMorePages: (limit: number | string, next: string) =>
    dispatch(
      connectedPageCRUDActions.retrieveAvailablePages(limit as number, next),
    ),
});

const enhance = compose<InnerProps, OuterProps>(
  connect(mapStateToProps, mapDispatchToProps),
);

export default enhance(ConnectPagesArea);
